function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M54.8555 0H9.14121C7.87693 0 6.8555 1.02143 6.8555 2.28571V61.7143C6.8555 62.9786 7.87693 64 9.14121 64H54.8555C56.1198 64 57.1412 62.9786 57.1412 61.7143V2.28571C57.1412 1.02143 56.1198 0 54.8555 0ZM36.2841 5.14286H43.1412V20.1357L39.8198 17.7143L36.2841 20.2429V5.14286ZM51.9984 58.8571H11.9984V5.14286H31.9984V26.35C31.9984 26.5857 32.0698 26.8214 32.2126 27.0143C32.2994 27.1369 32.4095 27.241 32.5368 27.3208C32.664 27.4005 32.8058 27.4542 32.9539 27.4788C33.1021 27.5034 33.2536 27.4983 33.3998 27.464C33.5459 27.4296 33.6838 27.3666 33.8055 27.2786L39.7912 23L45.6055 27.2429C45.7984 27.3857 46.0341 27.4643 46.2769 27.4643C46.9055 27.4643 47.4198 26.95 47.4198 26.3214V5.14286H51.9912V58.8571H51.9984Z",
  fill: "#373F51"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 64,
  height: 64,
  fill: "white"
})));

var SvgBook = function SvgBook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/book.85964068.svg";
export { ForwardRef as ReactComponent };